<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <v-card-title style="height: 64px">
        <div>
          <span class="title pl-2">{{partner.name}}</span>
          <span class="grey--text mx-2">正在编辑</span>
          <l-select-file
            v-if="!isEdit"
            :dialog-props="partnerFileProps"
            :hint="'仅支持Excel(.xlsx)文件'"
            :rules="partnerFileRules"
            @cancel="partnerFileProps.activate = false"
            @submit="readExcel"
            file-type="excel"
            select-type="dialog"
          >
            <v-btn class="mx-0" color="primary" flat
                   slot="activator">批量导入
            </v-btn>
            <template slot="before-drag">
              <v-layout align-center class="mb-3 pl-2" row>
                <span class="body-2">批量导入合作用户需要上传特定格式的模板</span>
                <v-btn
                  @click="getPartnerTemplate"
                  color="primary"
                  flat
                  ref="templateBtn"
                  small
                  target="_blank"
                >点此下载
                </v-btn>
              </v-layout>
            </template>
          </l-select-file>
        </div>
        <v-layout class="pl-4" wrap align-center>
          <v-flex v-if="isEdit" xs6>
            <span class="grey--text caption mr-2">上次更新</span>
            <span :class="partner.updateTime ? '':'grey--text'" class="pr-4">
              {{$L.time.stringify(partner.updateTime) || 'N/A'}}
            </span>
          </v-flex>
        </v-layout>
        <v-spacer></v-spacer>
        <v-btn v-if="isEdit" color="primary" flat @click="goReadonly">返回</v-btn>
      </v-card-title>
      <v-card-text>
        <v-container class="py-0" fluid grid-list-md>
          <v-form ref="partnerForm">
          <v-card class="pa-2">
          <v-layout class="mb-4" wrap>
            <v-flex xs12>
              <l-autocomplete
                label="单位"
                dense
                prepend-icon="$vuetify.icons.org"
                v-model="partner.org"
                :get-data="getOrgs"
                item-text="name"
                :rules="[$rules.requiredS()]"
              ></l-autocomplete>
            </v-flex>
            <v-layout v-if="partnerList.length===0">
              <v-flex xs12 md4>
                <v-text-field
                  label="姓名"
                  prepend-icon="$vuetify.icons.person"
                  v-model="partner.name"
                  :rules="[$rules.requiredS()]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  label="电话"
                  prepend-icon="$vuetify.icons.phone"
                  v-model="partner.phone"
                  :rules="[$rules.requiredS()]"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout v-else>
              <v-flex xs12>
                <l-data-table
                  :headers="header"
                  :items="partnerList"
                  hide-actions
                  hide-title></l-data-table>
              </v-flex>
            </v-layout>
          </v-layout>
          </v-card>
          </v-form>
        </v-container>
        <v-card class="ma-4">
          <v-container class="py-0" fluid grid-list-md>
            <v-layout>
              <v-layout column class="pl-4">
                <v-flex xs12>
                  <l-image v-if="driverLicense.length === 0"></l-image>
                  <l-image-dialog
                    :src="img.src"
                    v-for="(img,i) in driverLicense" :key="i">
                    <l-image
                      slot="activator"
                      :src="img.src"
                      :error="img.error"
                      :errorMessage="img.errorMessage"
                    >
                      <template slot="action">
                        <v-tooltip bottom>
                          <span>删除图像</span>
                          <v-btn slot="activator" @click="deleteImage(driverLicense, i)" icon>
                            <v-icon>$vuetify.icons.delete</v-icon>
                          </v-btn>
                        </v-tooltip>
                      </template>
                    </l-image>
                  </l-image-dialog>
                </v-flex>
                <v-flex xs12>
                </v-flex>
                <v-flex xs12  v-if="partnerList.length===0">
                  <l-select-file
                    @input="addFile(arguments[0], driverLicense)"
                    file-type="image/*"
                    title="添加图片"
                  >
                    <v-btn color="primary" flat slot="activator" :disabled="driverLicense.length===1||disabledFlag">
                      上传驾驶证<span class="error--text caption" >（至多只上传一张图片）</span>
                    </v-btn>
                  </l-select-file>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-container>
        </v-card>
      </v-card-text>
    </v-card>
    <v-layout class="py-2">
      <v-flex class="text-xs-right">
        <v-btn class="mx-0" color="primary" @click="setPartner">提交</v-btn>
      </v-flex>
    </v-layout>
  </l-layout>
</template>

<script>
  import XLSX from 'xlsx'
import LPlatePicker from '../../../../../components/LPlatePicker'
import LSelectDatetime from '../../../../../ladmin/components/LSelectDatetime/LSelectDatetime'
import SetPassRuleContent from '../../../../../components/SetPassRuleContent'
import LPassRuleList from '../../../../../components/LPassRuleList'
import {PassRule, ReservationAuthority, Group} from '../../../../../object'
import {time, F} from '../../../../../ladmin/utils'
import LDataTable from "../../../../../ladmin/components/LDataTable/LDataTable";
function NewPartner (id = 0, p = '', t = '', n = '', o = '', idt = '', idn = '') {
  return {
    id: id,
    name: p,
    ownerTel: t,
  }
}
let errorMap = {
  '1': '电话格式有误',
}
export default {
  name: 'partnerForm',
  components: {LDataTable, LSelectDatetime, LPlatePicker, SetPassRuleContent, LPassRuleList},
  props: {
    partner: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dialog: {
        activate: false,
        index: -1,
        plate: '',
        type: 'new'
      },
      orgList: [],
      /* 通行规则配置相关使用参数 */
      setRuleDialog: {
        activate: false,
        status: 'new',
        item: {},
        index: 0,
      },
      driverLicense: [],
      vehicleLicense: [],
      otherImage: [],
      disabledFlag: false,
      partnerList:[],
      importErrorDialog: {
        activate: false,
        partners: [],
        fails: [],
        duplicates: [],
      },
      header:[
        {text: '姓名', value: 'name', align: 'left'},
        {text: '手机', value: 'ownerTel', align: 'left'},
      ],
      partnerFileProps: {
        activate: true,
        autoClose: true,
        title: '批量导入合作用户',
      },
      partnerFileRules: [
        v => !(!v || v.length === 0) || '必选',
        v => !v.some(f => !/\.xlsx$/i.test(f.name)) || '仅支持Excel表格(.xlsx)格式',
      ],
    }
  },
  watch: {
    'partner.orgName': function () {
      let orgCode = this.orgList.filter((v) => (v.name === this.partner.orgName))[0].id
      this.partner.orgCode = orgCode
    },
    'partner.phone': function () {
      this.partner.code = this.partner.phone
    }
  },
  computed: {
    isEdit () {
      return this.$route.name === 'EditPartner'
    },
  },
  created () {
    if(this.isEdit){
      this.dealImg()
      this.dealContractEndTime()
    }
  },
  methods: {
    dealContractEndTime () {
      if (this.partner.contractEndTime !== '') {
        time.stringify(this.partner.contractEndTime)
      }
    },
    dealImg () {
      let picArray = JSON.parse(this.partner.fileJson).pic
      if (picArray.length === 0) {
        return
      }
      if (picArray[0].url1 !== null && picArray[0].url1 !== undefined) {
        let img = new Image()
        img.url = picArray[0].url1
        this.$set(this.driverLicense, this.driverLicense.length, img)
        // console.log(this.vehicleForm.driverLicense)
        this.getImg(img)
      }
      if (picArray[1].url2 !== null && picArray[1].url2 !== undefined) {
        let img = new Image()
        img.url = picArray[1].url2
        this.$set(this.vehicleLicense, this.vehicleLicense.length, img)
        // console.log(this.vehicleForm.driverLicense)
        this.getImg(img)
      }
      if (picArray[2].url3 !== null && picArray[2].url3 !== undefined) {
        let img = new Image()
        img.url = picArray[2].url3
        this.$set(this.otherImage, this.otherImage.length, img)
        this.getImg(img)
      }
    },
    async setPartner () {
      if (!this.$refs.partnerForm.validate()) {
        this.$L.alert('error', {message: '表单数据不合法'})
        return
      }
      try {
        if(this.partnerList.length === 0){
          let extend = {
            pic: [
              {name: '驾驶证', url1: (this.driverLicense.length === 0) ? '' : this.driverLicense[0].url},
              {name: '行驶证', url2: (this.vehicleLicense.length === 0) ? '' : this.vehicleLicense[0].url},
              {name: '其他证明', url3: (this.otherImage.length === 0) ? '' : this.otherImage[0].url}
            ],
            msg: ''
          }
          this.partner.file = JSON.stringify(extend)
          this.loading = true
          await this.$store.dispatch('mva/setPartners', [this.partner])
          this.$L.alert('success', `${this.isEdit ? '修改' : '添加'}成功`)
          await this.$L.tab.close(this.$L.tab.current, false)
          this.$router.push({
            name: 'PartnerList',
            params: {refresh: true}
          })
        }else{
          let arr = []
          for(let i=0;i<this.partnerList.length;i++){
            let p = this.partnerList[i]
            let obj = {
                'code': p.ownerTel,
                'name': p.name,
                'org': this.partner.org,
                'phone': p.ownerTel,
                'contractEndTime': '',
                'statusCode': '',
                'statusName': '',
                'deleteFlag': '',
                'updateTime': '',
                'vehicleList': '',
                passRules: []
              }
            let extend = {
              pic: [
                {name: '驾驶证', url1:  ''} ,
                {name: '行驶证', url2: ''},
                {name: '其他证明', url3:  ''}
              ],
              msg: ''
            }
            obj.file = JSON.stringify(extend)
            arr.push(obj)
          }
          this.loading = true
          await this.$store.dispatch('mva/setPartners', arr)
          this.$L.alert('success', `${this.isEdit ? '修改' : '添加'}成功`)
          await this.$L.tab.close(this.$L.tab.current, false)
          this.$router.push({
            name: 'PartnerList',
            params: {refresh: true}
          })
        }
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.loading = false
      }
    },
    deleteVehicle (i) {
      let list = this.vehicles.slice(0)
      list.splice(i, 1)
      this.vehicles = list
    },
    goReadonly () {
      this.$store.dispatch('L/routerInTab').then(() => {
        this.$router.replace({
          name: 'PartnerDetails',
          params: {name: this.partner.name},
          query: {code: this.partner.code}
        })
      })
    },
    async getOrgs (key) {
      try {
        let {items} = await this.$store.dispatch('userAdmin/getGroups', {
          pagination: {page: 1, rowsPerPage: 100},
          type: Group.ORGANIZATION,
          search: {key: 'name', value: key}
        })
        return items
      }
      catch (e) {
        this.$L.error(e.message)
      }
    },
    async addFile (file, target) {
      // file 实际上为fileList
      let imageCheckType = ['jpg', 'jpeg', 'png', 'gif']
      let IMAGE_MAX_SIZE = 5 * 1000 * 1000
      for (let f of file) {
        let checkType = imageCheckType
        let maxSize = IMAGE_MAX_SIZE
        // console.log('get file', f)
        let suffix = /\.([^.]*)$/i.exec(f.name)[1]
        if (checkType.indexOf(suffix) === -1) {
          this.$L.error({
            title: '上传文件格式错误',
            message: `上传格式: ${suffix}, 支持的格式: ${checkType.join(',')}`
          })
          return
        }
        else if (f.size > maxSize) {
          this.$L.error({
            title: '文件容量过大',
            message: `文件大小: ${Math.round(f.size / 1000)}KB, 最大限制: ${Math.round(maxSize / 1000)}KB`
          })
          return
        }
      }

      let temp = new Image()
      temp.loading = true
      if (target instanceof Array) {
        target.push(temp)
        // 上传图片
        let img = await this.uploadFile(file)
        this.$set(target, target.length - 1, img)
        // console.log(this.vehicleForm.driverLicense)
        this.getImg(img)
      }
    },
    deleteImage (target, i) {
      target.splice(i, 1)
    },
    async uploadFile (files) {
      if (files instanceof Object && files.length > 0) {
        let file = files[0]
        let img = new Image()
        // console.log(img)
        try {
          let res = await this.$store.dispatch('uploadFile', {file, url: '/passApi/check/file'})
          img.url = res
        }
        catch (e) {
          img.error = true
          img.errorMessage = e.message
        }
        return img
      }
    },
    async getImg (img) {
      // console.log(img)
      img.loading = true
      let path = img.url
      this.$set(img, 'src', 'https://smaco2.uestc.edu.cn/passApi' + path)
      img.loading = false
    },
    async getPartnerTemplate () {
      try {
        let url = await this.$store.dispatch('userAdmin/getPartnerTemplate')
        let isSupportDownload = 'download' in document.createElement('a')
        console.log('get url', url, isSupportDownload)
        let el = document.createElement('a')
        el.href = url
        el.target = '_blank'
        el.download = '合作用户批量导入模板'
        el.style.display = 'none'
        document.body.appendChild(el)
        el.click()
        document.body.removeChild(el)
      }
      catch (e) {
        this.$L.alert('error', {title: '获取模板时发生错误', message: e.message, raw: e})
      }
    },
    resetImportDialog () {
      this.importErrorDialog = {
        activate: false,
        partners: [],
        fails: [],
        duplicates: [],
      }
    },
    importPartners (partners) {
      if (partners) {
        this.partnerList.push(...partners)
        this.$L.alert('success', {message: `成功导入${partners.length}项`})
      }
      this.resetImportDialog()
    },
    checkPartners (v) {
      if (!this.$reg.PHONE_ALL.test(v.ownerTel.trim())) {
        return 1
      }
      return 0
    },
    readExcel (files) {
      let f = files[0]
      if (!(f instanceof File)) return
      let reader = new FileReader()
      reader.onload = (event) => {
        try {
          let data = event.target.result
          let workbook = XLSX.read(data, {type: 'array'})
          let keys = Object.keys(workbook.Sheets)
          if (Object.keys(workbook.Sheets).length < 1) {
            throw Error('模板格式错误')
          }
          let sheet = workbook.Sheets[keys[0]]
          let ref = sheet['!ref']
          let group = /^[A-Z]+(\d+):[A-Z]+(\d+)$/.exec(ref)
          if (!group) {
            throw Error('模板格式错误')
          }
          let s = Number(group[1])
          let e = Number(group[2])


          let atters = ['A', 'B', 'C', 'D', 'E', 'F']
          let partners = []
          let fails = []
          let duplicates = []

          for (let i = s + 1; i <= e; ++i) {
            let name = sheet[atters[0] + i] ? sheet[atters[0] + i].w.trim() : ''
            let phone = sheet[atters[1] + i] ? sheet[atters[1] + i].w.trim() : ''
            if (!name && !phone) {
              continue
            }
            let v = new NewPartner(
              this.partnerList.length + partners.length,
              name,
              phone,
            )
            let checkRes = this.checkPartners(v)
            if (checkRes === 0) {
              if (this.partnerList.find(t => t.phone === v.phone)) {
                duplicates.push(v)
              }else{
                partners.push(v)
              }
            }
            else {
              v.error = errorMap[checkRes]
              fails.push(v)
            }
          }
          console.log('check import', fails, duplicates, partners)
          if (fails.length === 0 && duplicates.length === 0) {
            this.importPartners(partners)
          }
          else {
            this.importErrorDialog = {
              activate: true,
              partners: partners,
              fails: fails,
              duplicates: duplicates,
            }
          }
        }
        catch (e) {
          this.$L.alert({title: '读取导入模板时发生错误', message: '给定的文件格式错误，或浏览器版本不支持'})
        }
      }
      reader.readAsArrayBuffer(f)
    },
  },
}
</script>

<style scoped>

</style>
